<template>
  <div id="app">
    <el-container>
      <el-header id="sysHead" height="90px">
        <sysHead></sysHead>
      </el-header>
      <el-container style="width: 100%">
        <el-aside id="sysAside" style="width: fit-content;">
          <el-scrollbar>
            <sysMenu v-height="40" v-if="menuflag"></sysMenu>
          </el-scrollbar>
        </el-aside>
        <el-main style="overflow-y: auto;padding: 0"  id="sysMain">
            <router-view v-on:logged="logged" v-on:outLogin="outLogin"/>
        </el-main>
        <div style="position: absolute; bottom: 0px; left: 10px;font-size:12px;">v2.2.6</div>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import sysMenu from './components/aside/menu.vue'
import sysHead from './components/header/head.vue'

export default {
  name: 'App',
  components: {
    sysMenu, sysHead
  },
  data(){
    return{
      menuflag:false
    }
  },
  mounted () {
    if(this.$util.fetch('menus')!=null){
      this.menuflag=true
    }
  },
  methods: {
    outLogin () {
      //console.log('outLogin')
      document.getElementById("sysHead").style.display= 'none';
      document.getElementById("sysAside").style.display= 'none';
      document.getElementById("sysMain").classList.add("back");
      this.menuflag=false
      this.$util.delete('menus')
      this.$util.delete('user_email')
    },
    logged () {
      //console.log('Logged')
      document.getElementById("sysHead").style.display='';
      document.getElementById("sysAside").style.display= '';
      document.getElementById("sysMain").classList.remove("back");
      this.menuflag=true
      },
  }
}
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left;
    color: #2c3e50;
  }
  .el-scrollbar__wrap{
    overflow-x: hidden;
  }
  .el-container {
    width: 100%;
  }

  .delete {
    margin-left: 10px;
    /*color: red;*/
    color: deepskyblue;
  }

  .update {
    margin-left: 10px;
    color: deepskyblue;
  }

  .content {
    margin-left: 10px;
    color: deepskyblue;
  }
  .back{
    height: 100vh;
    background: -moz-linear-gradient(left top,skyblue,white);
    background: -webkit-gradient(linear,left top,right bottom,color-stop(0,lightskyblue),color-stop(1,white));
  }
  .re-upload-img-btn {
    position: relative;
    overflow: hidden;
    height: 35px;
    line-height: 35px;
    margin: 0;
    background-color: #409eff;
    text-align: center;
    color: #fff;
    font-size: 14px;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 400;
  }

  .re-upload-img-btn:hover {
    background: #66b1ff;
  }

  .re-upload-img {
    visibility: hidden;
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  }

  .el-select-dropdown__list{
    list-style: none;
    padding: 6px 0;
    margin: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .a {
    color: deepskyblue;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue